module.exports = require('./helpers/bundle-url').getBundleURL('jWbtw') + "USDPLogo.d2d050af.svg";